const DEFAULT_JITTER_RATIO = 0.2;

export type JitterOptions = {
  jitterRatio?: number;
  minDelayMs?: number;
  maxDelayMs?: number;
  rounding?: "round" | "floor" | "ceil";
};

export function jitterDelayMs(
  baseDelayMs: number,
  options: JitterOptions = {},
): number {
  if (baseDelayMs <= 0) {
    return 0;
  }

  const jitterRatio = options.jitterRatio ?? DEFAULT_JITTER_RATIO;
  const minDelayMs = options.minDelayMs ?? 0;
  const maxDelayMs = options.maxDelayMs ?? Number.POSITIVE_INFINITY;
  const rounding = options.rounding ?? "round";

  const clampedBaseMs = Math.min(Math.max(baseDelayMs, minDelayMs), maxDelayMs);
  const jitterRange = clampedBaseMs * jitterRatio;
  const jitter = (Math.random() * 2 - 1) * jitterRange;
  const rawDelayMs = clampedBaseMs + jitter;

  const roundedDelayMs =
    rounding === "floor"
      ? Math.floor(rawDelayMs)
      : rounding === "ceil"
        ? Math.ceil(rawDelayMs)
        : Math.round(rawDelayMs);

  return Math.min(maxDelayMs, Math.max(minDelayMs, roundedDelayMs));
}
